<template>
  <!-- 订单详情弹框 -->
  <el-dialog
    class="detailDialog"
    title=""
    :visible.sync="logistDialog"
    :close-on-click-modal="false"
    width="480px"
  >
    <div class="logistics">
      <div class="title">{{ title }}详情</div>
      <div class="contentInfo">
        <div class="detailRow">
          <div class="namePhone">
            <span>{{ detailObj.name }}</span>
            <span class="phone">{{ detailObj.cellphone | isPoneMatch }}</span>
          </div>
          <div class="adderssWrap">
            <span class="name">收货地址:</span>
            <span class="addInfo">  {{ detailObj.address }}</span>
          </div>
        </div>
        <div class="detailRow">
          <div class="firstRow">
            <div class="leftImg">
              <img :src="detailObj.commodityAndRec.commodityImg" alt="">
            </div>
            <div class="goodInfo">
              <div class="oneRow">
                <span class="name"> {{ detailObj.commodityName }}</span>
                <span class="price"><i v-if="detailObj.symbolId==1">¥</i>{{ detailObj.commodityAndRec.price }} <i v-if="detailObj.symbolId!=1">{{ detailObj.symbolNameCh }}</i></span>
              </div>
              <div class="twoRow">
                <span class="name"><i>¥</i>{{ detailObj.commodityAndRec.price }}</span>
                <span class="price"><i>x</i>{{ detailObj.commodityAndRec.amount }}</span>
              </div>
            </div>
          </div>
          <div class="twosRow">
            <p v-if="detailObj.symbolId!=1" class="btwSty">
              <span class="name">商品总价</span>
              <span class="price">{{ Number((detailObj.commodityAndRec.amount * detailObj.commodityAndRec.price).toFixed(2)).toPrecision() }} <i>{{ detailObj.commodityAndRec.symbolNameCh }}</i></span>
            </p>
            <p v-else class="btwSty">
              <span class="name">商品总价</span>
              <span class="price"><i>¥</i>{{ Number((detailObj.commodityAndRec.amount * detailObj.commodityAndRec.price).toFixed(2)).toPrecision() }}</span>
            </p>
            <p class="btwSty">
              <span class="name">运费</span>
              <span class="price"><i>¥</i>{{ detailObj.expressFee }}</span>
            </p>
          </div>
          <div class="twosRow threesRow">
            <p class="btwSty">
              <span class="name">联系商家</span>
              <span class="contrant">{{ detailObj.contactCellphone }}</span>
            </p>
            <div class="btwSty">
              <span class="name">订单编号</span>
              <div class="rightInfo">
                <span class="orderNo">{{ detailObj.orderCode }} | </span>
                <span
                  v-clipboard:copy="detailObj.orderCode"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="copyInfo"
                >复制</span>
              </div>
            </div>
            <p class="btwSty">
              <span class="name">付款时间</span>
              <span class="time">{{ detailObj.commodityAndRec.createTime | dateFormate }}</span>
            </p>
          </div>
        </div>
        <div v-if="detailObj.commodityAndRec.orderStatus==1 ||detailObj.commodityAndRec.orderStatus==2" class="detailRow">
          <!-- <div v-if="name=='dh'" class="insertInfo">
            <div v-html="detailObj.commodityAndRec.expressSend"></div>
          </div> v-else-->
          <div class="twosRow threesRow">
            <p class="btwSty">
              <span class="name">快递名称</span>
              <span class="price">{{ detailObj.logisticsName }}</span>
            </p>
            <div class="btwSty">
              <span class="name">快递单号</span>
              <div class="rightInfo">
                <span class="orderNo">{{ detailObj.commodityAndRec.logisticsNumber }} | </span>
                <span
                  v-clipboard:copy=" detailObj.commodityAndRec.logisticsNumber"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="copyInfo"
                >复制</span>
              </div>
            </div>
            <p class="btwSty">
              <span class="name">发货时间</span>
              <span class="time">{{ detailObj.commodityAndRec.deliveryTime | dateFormate }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="actionWrap">
        <span class="savebtn" @click="closeDialog">确定</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>

/*global*/
export default {
  props: ['name'],
  data() {
    return {
      logistDialog: false,
      currentOrderId: null,
      isRepeat: false,
      title: '',
      countDown: '',
      copyCode: '',
      detailObj: {
        orderCode: null,
        name: null,
        cellphone: null,
        address: null,
        payStatus: null,
        payType: null,
        expressFee: null,
        isShowTk: false,
        commodityAndRec: {
          amount: null,
          applyTime: null,
          commodityCode: '',
          commodityName: '',
          commodityPicture: '',
          autoReceiveDeadline: null,
          createTime: null,
          expressSend: null,
          deliveryTime: null,
          logisticsCompany: null,
          logisticsNumber: null,
          orderDetailId: null,
          orderId: null,
          orderStatus: null,
          payAmount: null,
          price: null,
          productId: null,
          specificationsId: null,
          specificationsInfo: null
        }
      }
    }
  },
  methods: {
    showDialog(row) {
      // this.currentOrderId = orderId
      this.getDetail(row)
    },
    closeDialog() {
      this.logistDialog = false
      this.copyCode = ''
    //   this.detailObj = {
    //     orderCode: null,
    //     name: null,
    //     cellphone: null,
    //     address: null,
    //     payStatus: null,
    //     payType: null,
    //     expressFee: null,
    //     isShowTk: false,
    //     commodityAndRec: {
    //       amount: null,
    //       applyTime: null,
    //       commodityCode: '',
    //       commodityName: '',
    //       commodityPicture: '',
    //       autoReceiveDeadline: null,
    //       createTime: null,
    //       deliveryTime: null,
    //       logisticsCompany: null,
    //       logisticsNumber: null,
    //       orderDetailId: null,
    //       orderId: null,
    //       orderStatus: null,
    //       payAmount: null,
    //       price: null,
    //       productId: null,
    //       specificationsId: null,
    //       specificationsInfo: null
    //     }
    //   }
    },
    getDetail(row) {
      // // 订单状态：0:待发货；1：待收货；2：已完成；3：已取消 5:支付中
      // protocol.param_findShopOrderDetailInfo.param.orderId = this.currentOrderId
      // http
      //   .postFrontMall(protocol.param_findShopOrderDetailInfo)
      //   .then(response => {
      //     const { code, message, value } = response.data
      //     if (code === 0 || code === '0') {
      //       this.detailObj = {
      //         orderCode: value.orderCode,
      //         name: value.name,
      //         payStatus: value.payStatus,
      //         payType: value.payType,
      //         cellphone: value.cellphone,
      //         address: value.address,
      //         expressFee: value.expressFee,
      //         commodityAndRec: value.commodityAndRec.content.length ? value.commodityAndRec.content[0] : {},
      //         isShowTk: false
      //       }
      //       const detail = this.detailObj.commodityAndRec
      //       // 是否展示退款  returnDeadline退款期限  createTime创建时间
      //       // eslint-disable-next-line eqeqeq
      //       if (detail.orderStatus == 0) {
      //         const returnDeadline = detail.returnDeadline * 24 * 60 * 60 * 1000 // 剩余可取消的期限毫秒
      //         const currentTime = new Date().getTime()
      //         const leftTime = currentTime - detail.createTime // 过了多长时间
      //         if (leftTime < returnDeadline) {
      //           this.detailObj.isShowTk = true
      //         } else {
      //           this.detailObj.isShowTk = false
      //         }
      //       } else {
      //         this.detailObj.isShowTk = false
      //       }

      //       this.addressObj = {
      //         name: value.name,
      //         cellphone: value.cellphone,
      //         address: value.address
      //       }
      //       this.title = ''
      //       this.countDown = ''
      //       this.copyCode = this.detailObj.orderCode
      //       // PC端不展示自动确认时间
      //       // if (detail.orderStatus === 1) {
      //       //   this.calcTime(detail.deliveryTime, detail.autoReceiveDeadline)
      //       // }
      //       this.judgeTitle(detail.orderStatus)
      //       this.logistDialog = true
      //     } else {
      //       this.$message(message)
      //     }
      //   })
      //   .catch(() => {})

      // 订单状态：0:待发货；1：待收货；2：已完成；3：已取消 5:支付中
      const value = row
      this.detailObj = {
        orderCode: value.orderCode,
        name: value.name,
        payStatus: value.payStatus,
        payType: value.payType,
        cellphone: value.cellphone,
        address: value.address,
        expressFee: value.expressFee,
        commodityName: value.commodityName,
        symbolNameCh: value.symbolNameCh,
        symbolId: value.symbolId,
        contactCellphone: value.contactCellphone,
        logisticsName: value.logisticsName,
        commodityAndRec: value.orderDetail,
        isShowTk: false
      }
      const detail = this.detailObj.commodityAndRec
      // 是否展示退款  returnDeadline退款期限  createTime创建时间
      // eslint-disable-next-line eqeqeq
      if (detail.orderStatus == 0) {
        const returnDeadline = detail.returnDeadline * 24 * 60 * 60 * 1000 // 剩余可取消的期限毫秒
        const currentTime = new Date().getTime()
        const leftTime = currentTime - detail.createTime // 过了多长时间
        if (leftTime < returnDeadline) {
          this.detailObj.isShowTk = true
        } else {
          this.detailObj.isShowTk = false
        }
      } else {
        this.detailObj.isShowTk = false
      }

      this.addressObj = {
        name: value.name,
        cellphone: value.cellphone,
        address: value.address
      }
      this.title = ''
      this.countDown = ''
      this.copyCode = this.detailObj.orderCode
      // PC端不展示自动确认时间
      // if (detail.orderStatus === 1) {
      //   this.calcTime(detail.deliveryTime, detail.autoReceiveDeadline)
      // }
      this.judgeTitle(detail.orderStatus)
      this.logistDialog = true
    },
    calcTime(time, autoReceiveDeadline) {
      // 倒计时 8天4小时
      // 如果1号13:01发货，自动收货确认时间是13:00 省略分钟
      // 如果1号13:00发货 ，自动收货确认时间是13:00
      // 处理发货时间
      const deliverDayTime = this.deliverDateFormate(time)
      const currentTime = this.deliverDateFormate(new Date().getTime())
      const lastTime = deliverDayTime + autoReceiveDeadline * 24 * 60 * 60 * 1000
      const leftTime = (lastTime - currentTime) // 剩余多少时间毫秒  + 1 * 24 * 60 * 60 * 1000
      const day = parseInt(leftTime / (3600000 * 24))
      const hour = parseInt((leftTime % (3600000 * 24)) / 3600000)
      this.countDown = (day > 0 ? (day + '天') : '') + (hour > 0 ? (hour + '小时') : '')
    },
    // 0待发货  9退款中   1待收货   2已完成 3 退款成功
    judgeTitle(orderStatus) {
      switch (orderStatus) {
        case 0:
          this.title = '待发货'
          break
        case 1:
          this.title = '待收货'

          break
        case 2:
          this.title = '已完成'
          break
        case 3:
          this.title = '退款成功'
          break
        case 8:
          this.title = '缺货退款'
          break
        case 9:
          this.title = '退款中'
          break
        default:
          this.title = ''
      }
    },
    onCopy(e) {
      this.$message('你复制了：' + e.text)
    },
    onError() {
      this.$message('请重新复制')
    }
  }
}
</script>
<style lang="scss">
    .insertInfo{
      img{
        width:100%;
      }
    }
  </style>
  <style lang="scss" scoped>

  .detailDialog{
    /deep/.el-dialog{
          background: #424556!important;
          border-radius: 8px 8px 8px 8px;
      }
      /deep/.el-dialog__header{
          display: none;
      }
      /deep/.el-dialog__body{
          padding:40px;
      }
      .title{
          font-size: 24px;
          font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
          font-weight: bold;
          color: #FFFFFF;
          text-align: center;
      }
      .detailRow{
        margin-top:20px;
        padding:10px;
        background: #292C3A;
        border-radius: 4px 4px 4px 4px;
        .namePhone{
            display: flex;
            align-items: center;
            font-size: 20px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 23px;
            .phone{
                margin-left:20px;
                font-size: 22px;
                font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
                font-weight: normal;
                color: #FFFFFF;
                line-height: 26px;
            }
        }
        .adderssWrap{
            display: flex;
            margin-top:10px;
            .name{
                width: 80px;
                font-size: 18px;
                font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 21px;
            }
            .addInfo{
                width:calc(100% - 80px);
                font-size: 18px;
                font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 21px;
            }
        }
      }
      .firstRow{
        display: flex;
        align-items: flex-start;
        .leftImg{
            width: 70px;
            margin-right: 10px;
            img{
                width: 70px;
                height: 70px;
                border-radius: 2px 2px 2px 2px;
            }
        }
        .goodInfo{
            width:calc(100% - 80px);
        }
        i{
            font-style: normal;
            font-size: 10px;
            font-family: PingFang HK-Semibold, PingFang HK;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 12px;
        }
        .oneRow{
           display: flex;
           justify-content: space-between;
            align-items: center;
            .name{
                max-width:70%;
                font-size: 18px;
                font-family: PingFang HK-Medium, PingFang HK;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 21px;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                overflow: hidden;
            }
            .price{
                font-size: 18px;
                font-family: PingFang HK-Semibold, PingFang HK;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 21px;
            }
        }
        .twoRow{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:10px;
            i{
                font-size: 12px;
                line-height: 14px;
            }
            .name{
                font-size: 18px;
                font-family: PingFang HK-Semibold, PingFang HK;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 21px;
            }
            .price{
                font-size: 16px;
                font-family: PingFang HK-Semibold, PingFang HK;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 19px;
            }
        }
      }
      .twosRow{
        border-bottom: 1pxsolid #424556;
        .btwSty{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:10px;
        }
        .name{
            font-size: 16px;
            font-family: PingFang HK-Regular, PingFang HK;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 19px;
        }
        .price{
            font-size: 16px;
            font-family: PingFang HK-Semibold, PingFang HK;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 19px;
            i{
                font-style: normal;
                font-size: 12px;
                font-family: PingFang HK-Semibold, PingFang HK;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 14px;
            }
        }
      }
      .threesRow{
        .contrant{
            font-size: 16px;
            font-family: PingFang HK-Regular, PingFang HK;
            font-weight: 400;
            color: #E4CA91;
            line-height: 19px;
        }
        .rightInfo{
            .orderNo{
                font-size: 16px;
                font-family: PingFang HK-Regular, PingFang HK;
                font-weight: 400;
                color: #999999;
                line-height: 19px;
            }
            .copyInfo{
                font-size: 16px;
                font-family: PingFang HK-Semibold, PingFang HK;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 19px;
                cursor: pointer;
            }
        }
        .time{
            font-size: 16px;
            font-family: PingFang HK-Regular, PingFang HK;
            font-weight: 400;
            color: #999999;
            line-height: 19px;
        }
      }
    .actionWrap{
          margin-top:40px;
          display: flex;
          justify-content: center;
      }

      .savebtn{
          margin-left: 20px;
          width:95px;
          display: inline-block;
          height: 40px;
          background: #E4CA91;
          border-radius: 4px 4px 4px 4px;
          font-size: 14px;
          font-family: PingFang HK-Medium, PingFang HK;
          font-weight: 500;
          color: #5E4207;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
      }
  }
  </style>

